import React from 'react';
import PropTypes from 'prop-types';

import { useConfig } from 'Context/ConfigContext';

import {
  useClearByLearnEd,
  SUBMISSION_STATE,
} from '../Contexts/ClearByLearnEdProvider/ClearByLearnEdProvider';
import useMyExternalProfile from '../../../Domain/useMyExternalProfile';

import ClearTicketReview from './ClearTicketReview';
import ClearButton from './ClearButton';
import ClearTicketForm from './ClearTicketForm';
import ClearExitConfirmModal from './ClearExitConfirmModal';
import ClearErrorModal from './ClearErrorModal';
import ClearCompleteModal from './ClearCompleteModal';

const MODAL_ACTIVE_STATE = [
  SUBMISSION_STATE.SUBMITTING,
  SUBMISSION_STATE.REVIEWING,
  SUBMISSION_STATE.FILLING_FORM,
];

const ClearByLearnEd = ({ onClickVideoEndingOverlayContent, isVideoEndingOverlayButton }) => {
  const [submissionState, , { reset }] = useClearByLearnEd();

  const { classroom: classroomConfig } = useConfig();
  const enableClearByLearnEd = classroomConfig?.clearByLearnEd?.enable;

  const { data } = useMyExternalProfile({ fetchPolicy: 'cache-only' });
  const providerName = data?.myExternalProfile?.providerName ?? '';

  if (!enableClearByLearnEd || providerName !== 'learned') return null;

  if (submissionState === SUBMISSION_STATE.COMPLETED) return <ClearCompleteModal />;
  if ([SUBMISSION_STATE.FAILED, SUBMISSION_STATE.RE_SUBMITTING].includes(submissionState)) {
    return <ClearErrorModal />;
  }

  return (
    <>
      <ClearButton
        onClickVideoEndingOverlayContent={onClickVideoEndingOverlayContent}
        isVideoEndingOverlayButton={isVideoEndingOverlayButton}
      />
      <ClearExitConfirmModal
        muiProps={{ isActive: MODAL_ACTIVE_STATE.includes(submissionState), onClose: reset }}
      >
        {submissionState === SUBMISSION_STATE.FILLING_FORM && <ClearTicketForm />}
        {[SUBMISSION_STATE.SUBMITTING, SUBMISSION_STATE.REVIEWING].includes(submissionState) && (
          <ClearTicketReview />
        )}
      </ClearExitConfirmModal>
    </>
  );
};

ClearByLearnEd.propTypes = {
  onClickVideoEndingOverlayContent: PropTypes.func,
  isVideoEndingOverlayButton: PropTypes.bool,
};

export default ClearByLearnEd;
